import { Navigate, useLocation } from "react-router-dom";
import { useAuthStore } from "@/stores/auth";

interface Props {
  children: React.ReactNode;
}

/**
 * Wrap route cần auth. Nếu chưa login → redirect /login + nhớ `from` để
 * sau login tự đẩy về trang đang xem.
 */
export function ProtectedRoute({ children }: Props) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return <>{children}</>;
}
